export const isProduction = process.env.NODE_ENV === 'production';

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS || '';
export const BASE_URL = process.env.REACT_APP_LISTARE_BASE_URL || '';
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
